const debounce = require("lodash/debounce");

function handleResize() {
  const showcases = document.querySelectorAll(".block-post_showcase");
  if (showcases) {
    showcases.forEach((showcase) => {
      const image = showcase.querySelector(".post-image img");
      const postPreview = document.querySelector(".post-preview");
      // Reset and return on tablet/mobile
      if (window.matchMedia("(max-width: 768px)").matches) {
        image.style.minHeight = "";
        postPreview.style.minHeight = "";
        return;
      }

      // Reset before getting their real values.
      image.style.minHeight = "";
      postPreview.style.minHeight = "";
      if (postPreview.getBoundingClientRect().height > image.height) {
        // Match image to post preview.
        image.style.minHeight = `${
          postPreview.getBoundingClientRect().height
        }px`;
      } else if (postPreview.getBoundingClientRect().height < image.height) {
        // Otherwise, match post preview to image.
        postPreview.style.minHeight = `${image.height}px`;
      }
    });
  }
}

window.addEventListener("DOMContentLoaded", function () {
  const showcases = document.querySelectorAll(".block-post_showcase");
  if (showcases) {
    window.addEventListener("resize", debounce(handleResize, 100));
    handleResize();
    showcases.forEach((showcase) => {
      const img = showcase.querySelector(".post-image img");
      img.addEventListener("load", handleResize);
    });
  }
});
